import { HttpClient, } from "@angular/common/http";
import ptBr from "@angular/common/locales/pt";
import { EnvironmentService } from "./core/environment/environment.service";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { registerLocaleData } from "@angular/common";
import { DatadogService } from "./shared/services/datadog/datadog.service";
import { SdkAnalyticsService } from './shared/services/sdk-analytics/sdk-analytics.service';
import { AnalyticsConfig } from './shared/interface/sdk-analytics';
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, "./assets/i18n/", // or whatever path you're using
    ".json");
}
// Fallback estático
var analyticsConfig = {
    sdkUrl: 'https://sdk-analytics-web.cloud.itau.com.br/index.js',
    gtmId: 'GTM-MKWS5TC',
    defaultParameters: {
        business: 'investimentos-app-e-web',
        business_channel: 'portal-is-ativos',
        environment: 'logado'
    },
    timeoutMs: 1500
};
registerLocaleData(ptBr);
var ɵ0 = window, ɵ1 = analyticsConfig, ɵ2 = function (env, sdk, datadogService) { return function () {
    return env.loadEnvironment().toPromise().then(function (res) {
        var envAnalytics = res && res.analyticsSettings ? res.analyticsSettings : null;
        var effectiveConfig = {
            sdkUrl: envAnalytics && envAnalytics.sdkUrl ? envAnalytics.sdkUrl : analyticsConfig.sdkUrl,
            gtmId: envAnalytics && envAnalytics.gtmId ? envAnalytics.gtmId : analyticsConfig.gtmId,
            defaultParameters: envAnalytics && envAnalytics.defaultParameters ? envAnalytics.defaultParameters : analyticsConfig.defaultParameters,
            timeoutMs: envAnalytics && envAnalytics.timeoutMs !== undefined ? envAnalytics.timeoutMs : analyticsConfig.timeoutMs
        };
        return sdk.loadSdk(effectiveConfig.gtmId, effectiveConfig.sdkUrl, effectiveConfig.defaultParameters).then(function () {
            datadogService.configureDataDog();
        }).catch(function () { });
    });
}; }, ɵ3 = function (service) { return function () { return service.loadEnvironment().toPromise(); }; }, ɵ4 = function () { return new Promise(function () { }); };
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
